
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import { mapState, mapGetters } from "vuex";
import $ from "jquery";
import { Rules } from "@/helpers/enums/Roles";
import { Roles } from "@/helpers/enums/Roles";
import router from "@/router";

export default defineComponent({
  name: "ag-nav",
  data() {
    return {
      collapse: false,
    };
  },
  setup() {
    const { t, locale } = useI18n();
    return { t, locale, Rules, Roles };
  },
  computed: {
    ...mapState({
      agmsGroup: (state: any) => state.auth.agmsGroup,
      agmsSite: (state: any) => state.auth.agmsSite,
      agmsTemplate: (state: any) => state.auth.agmsTemplate,
    }),
    ...mapGetters(["loggedInUser"]),
  },
  props: {
    data: {
      type: Array,
      default: null,
    },
  },
  mounted() {
    let sections = $("li .nav-item");
    for (let i = 0; i < sections.length; i++) {
      if ($(sections[i]).find("a").hasClass("router-link-exact-active")) {
        $(sections[i]).find("a").parent().parent().addClass("show");
      }
    }
  },
  methods: {
    createMasterUrl(navItem: any) {
      let firstChild = navItem.children.filter(
        (f: { rules: string | Rules[] }) =>
          (f.rules &&
            f.rules.includes(Rules.AGMSGroupSelect) &&
            this.agmsGroup.mainid) ||
          (f.rules &&
            f.rules.includes(Rules.AGMSTemplateSelect) &&
            this.agmsTemplate.mainid &&
            this.agmsTemplate.templateType != 2) ||
          (f.rules &&
            f.rules.includes(Rules.AGMSTemplateSelect) &&
            f.rules.includes(Rules.AGMSTemplateType2Select) &&
            this.agmsTemplate.mainid &&
            this.agmsTemplate.templateType == 2) ||
          !f.rules
      );
      if (
        this.loggedInUser.role === Roles.AGMSAdmin &&
        navItem.link === "administration"
      ) {
        firstChild = navItem.children.filter(
          (f: any) => f.link === "manage-partners"
        );
      }
      if (
        this.loggedInUser.role === Roles.CompanyAdmin &&
        navItem.link === "administration"
      ) {
        firstChild = navItem.children.filter(
          (f: any) => f.link === "manage-dashboard"
        );
      }
      if (
        this.loggedInUser.role === Roles.SiteAdmin &&
        navItem.link === "administration"
      ) {
        firstChild = navItem.children.filter(
          (f: any) => f.link === "site-overview"
        );
      }
      if (
        this.loggedInUser.role === Roles.GroupAdmin &&
        navItem.link === "administration"
      ) {
        firstChild = navItem.children.filter(
          (f: any) => f.link === "group-dashboard"
        );
      }
      if (
        this.loggedInUser.role === Roles.SiteAdmin &&
        navItem.link === "settings"
      ) {
        firstChild = navItem.children.filter(
          (f: any) => f.link === "pdp-lrp-list"
        );
      }
      if (
        this.loggedInUser.role === Roles.GroupAdmin &&
        navItem.link === "settings"
      ) {
        firstChild = navItem.children.filter(
          (f: any) => f.link === "pdp-lrp-list"
        );
      }
      if (
        this.loggedInUser.role === Roles.CompanyAdmin &&
        navItem.link === "settings"
      ) {
        firstChild = navItem.children.filter(
          (f: any) => f.link === "sso-settings"
        );
      }
      return `/${navItem.link}${
        firstChild.length ? "/" + firstChild[0].link : ""
      }`;
    },
    toggleMenu(param: any) {
      if (
        param &&
        param?.currentTarget &&
        param?.currentTarget.classList.contains("router-link-exact-active")
      )
        this.$router.go(0);

      $(".collapse").removeClass("show");
      $("[aria-expanded=true]").attr("aria-expanded", "false");
    },
    reloadCurrentPath(param: any) {
      if (
        param &&
        param?.currentTarget &&
        param?.currentTarget.classList.contains("router-link-exact-active")
      )
        this.$router.go(0);
    },
  },
});
